import { GET_API } from "./index";
import * as SYSTEM from "../constants/system.keys";

export const getAddress = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/geocode`,
    token,
    dataHeader,
    dataQuery
  );
};